<template>
  <div class="custom-dropdown">
    <!-- 下拉框标题 -->
    <div class="custom-dropdown-title" @click="open">
      <span class="selectlabel">{{ type }}:</span>
      <input class="selectinput" type="text" readonly :value="selectedText" />

      <van-icon
        style="margin-left: 5px; font-size: 18px"
        name="search"
        :badge="selectedlength"
      />
    </div>
    <!-- 下拉框弹窗 -->
    <van-popup
      style="height: 50%; min-width: 300px"
      v-model="popupVisible"
      position="bottom"
    >
      <van-checkbox-group v-model="selectedValues" @change="handleSearch">
        <!-- 下拉框选项列表 -->
        <van-cell-group>
          <van-field
            @input="handleSearchInput"
            v-model="textField"
            label="搜索"
            placeholder="请输入景区名称"
          />
        </van-cell-group>
        <van-cell-group>
          <van-cell
            v-for="option in filterstorelist"
            :key="getOptionKey(option[data.id])"
            clickable
          >
            <!-- <van-checkbox
              :name="getOptionKey(option[data.id])"
              :shape="shape"
              :checked="isSelected(option)"
            >
              {{ getOptionKey(option[data.value]) }}
            </van-checkbox> -->
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <!-- 操作按钮 -->
      <div class="custom-dropdown-buttons">
        <van-button type="info" size="small" @click="resetSelected">
          重置
        </van-button>
        <van-button
          style="margin-left: 5px"
          type="primary"
          size="small"
          @click="confirmSelected"
        >
          确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    //  列表
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    shape: {
      type: String,
      default: "round",
    },
    // 标题
    type: {
      type: String,
      default: "",
    },
    // 传输的id和value
    data: Object,
    default: () => {},
  },
  data() {
    return {
      textField: "", // 输入框的内容
      storelist: [], // 原来的列表
      filterstorelist: [], // 过滤后数组
      client: window.innerWidth, // 屏幕宽度
      selectedValues: [...this.value],
      popupVisible: false,
      selectedOptions: [],
      throttleTimer: null, // 节流计时器
    };
  },
  computed: {
    selectedlength() {
      if (this.selectedOptions.length === 0) {
        return "0";
      } else {
        let text;
        if (this.selectedOptions.length > 0) {
          text = `${this.selectedOptions.length}`;
        }
        return text;
      }
    },
    selectedText() {
      if (this.selectedOptions.length === 0) {
        return `选择${this.type}`;
      } else {
        let text = "";
        this.selectedOptions.forEach((option, index) => {
          text += option[this.data.value];
          if (index < this.selectedOptions.length - 1) {
            text += ", ";
          }
        });
        return text;
      }
    },
  },
  created() {},
  mounted() {
    console.log("传输过来的数据", this.storelist);
    console.log(this.filterstorelist, "过滤后得数据");
  },
  methods: {
    // 返回筛选值
    getOptionKey(value) {
      return value;
    },
    open() {
      // 清除之前的节流计时器
      if (this.throttleTimer) {
        clearTimeout(this.throttleTimer);
      }
      // 设置新的节流计时器
      this.throttleTimer = setTimeout(() => {
        this.storelist = this.options.slice(0, 100);
        if (this.filterstorelist.length === 0) {
          if (this.storelist.length > 0) {
            this.filterstorelist = this.storelist;
          } else {
            this.filterstorelist = [];
          }
        } else {
          if (this.type === "设备") {
            this.filterstorelist = this.storelist;
          }
          this.storelist.forEach((item) => {
            this.selectedOptions.forEach((o) => {
              if (item.id === o.id) {
                // 删除原来的位置
                const index = this.filterstorelist.indexOf(item);
                if (index > -1) {
                  this.filterstorelist.splice(index, 1);
                }
                // 将符合条件的元素放到最前面
                this.filterstorelist.unshift(item);
              } else {
                this.filterstorelist.unshift(o);
              }
            });
          });
          // 去重
          this.filterstorelist = this.filterstorelist.filter(
            (item, index, self) =>
              index ===
              self.findIndex((t) => JSON.stringify(t) === JSON.stringify(item))
          );
        }
        this.popupVisible = true;
      }, 200); // 设置节流时间间隔为500毫秒
    },
    handleSearch() {
      console.log(this.selectedOptions);
      this.$emit("anyinput", this.selectedOptions, this.type);
      // this.storelist = this.options
    },
    // 进行模糊查询
    handleSearchInput(value) {
      console.log(value);
      if (value) {
        var v = this.data.value;
        let checklist = this.options.filter((sp) => sp[v].includes(value));
        this.filterstorelist = [];
        this.filterstorelist.unshift(...checklist);
      } else {
        // this.storelist = this.options;
      }
    },
    isSelected(option) {
      const isSelected = this.selectedValues.includes(option[this.data.id]);
      if (
        isSelected &&
        !this.selectedOptions.some((item) => item.id === option.id)
      ) {
        this.selectedOptions.push(option);
      } else if (
        !isSelected &&
        this.selectedOptions.some((item) => item.id === option.id)
      ) {
        const index = this.selectedOptions.indexOf(option);
        this.selectedOptions.splice(index, 1);
      }
      return isSelected;
    },
    resetSelected() {
      this.selectedValues = [...this.value];
      this.selectedOptions = [];
      this.textField = "";
      this.filterstorelist = this.storelist.slice(0, 100);
      this.$emit("anyclear", this.type);
    },
    confirmSelected() {
      this.$emit("anyinput", this.selectedOptions, this.type);
      this.storelist = this.options;
      this.popupVisible = false;
    },
  },
};
</script>

<style scoped>
.selectlabel {
  font-size: 14px;
  color: #666;
}

.selectinput {
  width: 200px;
  margin-left: 10px;
  padding-left: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  font-size: 14px;
  color: #666;
}

.custom-dropdown {
  height: 35px;
  position: relative;
}

.custom-dropdown-title {
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
  background-color: #fff;
  border: 0px solid #e6e6e6;
  border-radius: 4px;
  text-align: left;
  /*overflow: hidden;*/
  white-space: nowrap;
  text-overflow: ellipsis;
}

.custom-dropdown-buttons {
  z-index: 10;
  position: fixed !important;
  right: 0;
  bottom: 0;
  margin: 10px;
  text-align: right;
}
</style>